import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { convertToViewModelToInput } from "./composition/convert-view-model-to-input";
import { PlanStockUpdate_StockManagementPage_Mutation } from "./mutation";

import type { PlanStockDiffStore } from "../../../usecase/use-create-form-model/plan-stock-diff-store";
import type { ServerModel } from "../../../usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	planStockDiffStore: PlanStockDiffStore;

	onReInitialize: () => void;
};

export const useUpdatePlanStock = ({ serverModel, planStockDiffStore, onReInitialize }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(PlanStockUpdate_StockManagementPage_Mutation);

	const onUpdatePlanStock = useCallback(async () => {
		showLoadingScreenCallback();

		const input = convertToViewModelToInput({ serverModel, planStockDiffStore });

		const { errors } = await mutationFunc({
			variables: {
				input,
			},
		}).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "プラン在庫を更新しました",
			});

			onReInitialize();
		}
	}, [
		hideLoadingScreenCallback,
		mutationFunc,
		onReInitialize,
		planStockDiffStore,
		serverModel,
		showLoadingScreenCallback,
	]);

	return {
		onUpdatePlanStock,
	};
};
